import { useState } from "react";
import { motion } from "framer-motion";

export default function RMASistemasSite() {
  const [menuOpen, setMenuOpen] = useState(false);

  const sections = [
    { id: "home", label: "Início" },
    { id: "tributos", label: "Reforma Tributária" },
    { id: "servicos", label: "Serviços" },
    { id: "modulos", label: "Módulos" },
    { id: "preco", label: "Preço" },
    { id: "contato", label: "Contato" },
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Top Bar */}
      <header className="sticky top-0 z-40 backdrop-blur bg-white/80 border-b border-slate-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-100 via-blue-100 to-blue-100 opacity-90" >
          <div className="flex h-20 items-center justify-between">
            <div className="flex items-center gap-3">
              {/* Logo placeholder — substitua /logo.png pelo seu arquivo */}
              <img src="logo.svg" width="180px" height="250px"/>
            </div>
            <nav className="hidden md:flex items-center gap-6">
              {sections.map(s => (
                <a key={s.id} href={`#${s.id}`} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition">
                  {s.label}
                </a>
              ))}
              <a href="#contato" className="inline-flex items-center rounded-2xl border border-slate-300 px-4 py-2 text-sm font-semibold bg-slate-900 text-white hover:opacity-90">
                Fale Conosco
              </a>
            </nav>
            <button onClick={()=>setMenuOpen(v=>!v)} className="md:hidden p-2 rounded-xl border border-slate-300" aria-label="Abrir menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6"><path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/></svg>
            </button>
          </div>
        </div>
        {menuOpen && (
          <div className="md:hidden border-t border-slate-200 bg-white">
            <div className="px-4 py-3 flex flex-col gap-2">
              {sections.map(s => (
                <a key={s.id} href={`#${s.id}`} className="py-2 text-sm font-medium text-slate-700" onClick={()=>setMenuOpen(false)}>
                  {s.label}
                </a>
              ))}
              <a href="#contato" onClick={()=>setMenuOpen(false)} className="mt-2 inline-flex items-center justify-center rounded-2xl border border-slate-300 px-4 py-2 text-sm font-semibold bg-slate-900 text-white">
                Fale Conosco
              </a>
            </div>
          </div>
        )}
      </header>

      {/* Hero */}
      <section id="home" className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-blue-700 opacity-90" />
        <svg className="absolute -top-10 -right-10 w-[600px] h-[400px] opacity-20" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="#ffffff" d="M44.8,-63.9C57.5,-57.2,67.3,-46,74.6,-33.2C81.9,-20.5,86.7,-6.3,86.1,7.5C85.6,21.3,79.6,34.6,70.8,45.8C62,57,50.4,66.2,37.3,72.3C24.2,78.4,9.6,81.6,-4.3,86.6C-18.2,91.6,-36.5,98.4,-48.3,93.2C-60.1,88,-65.6,70.7,-71.1,55.2C-76.6,39.7,-82.1,26,-85.1,11.5C-88.1,-3.1,-88.6,-17.5,-82.3,-28.5C-76.1,-39.4,-63.1,-46.8,-50.5,-53.2C-37.9,-59.6,-25.7,-65,-12.3,-67.3C1.1,-69.7,22.2,-69.1,44.8,-63.9Z" transform="translate(100 100)" />
        </svg>
        <div className="relative mx-auto max-w-7xl px-6 py-24 sm:py-28 lg:py-10 text-white">
          <motion.h1 initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} transition={{duration:0.5}} className="text-3xl sm:text-4xl font-extrabold tracking-tight">
            Especialistas em TOTVS Protheus
          </motion.h1>
          <motion.p initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} transition={{delay:0.1,duration:0.5}} className="mt-4 max-w-2xl text-base sm:text-lg text-slate-100">
            Implantação, melhorias, integrações e suporte em todo o ecossistema Protheus. Foco em conformidade fiscal, performance e resultados.
          </motion.p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="#tributos" className="rounded-2xl bg-white text-slate-900 px-5 py-3 text-sm font-semibold shadow hover:opacity-90">Reforma Tributária</a>
            <a href="#contato" className="rounded-2xl border border-white/60 px-5 py-3 text-sm font-semibold hover:bg-white/10">Solicite uma proposta</a>
          </div>
          {/*<p className="mt-6 text-sm opacity-90">Valor hora: <span className="font-semibold">R$ 85,00</span> <span className="opacity-80">(sem impostos)</span></p>*/}
        </div>
      </section>

      {/* Reforma Tributária - Configurador de Tributos */}
      <section id="tributos" className="mx-auto max-w-7xl px-6 py-2 relative overflow-hidden bg-gradient-to-br from-slate-200 via-blue-100 to-blue-200">
        <div className="grid lg:grid-cols-1 gap-8 items-center">
          <div>
            <center><h2 className="text-2xl sm:text-2xl font-bold text-slate-900">Reforma Tributária e Configurador de Tributos</h2></center>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <p className="mt-4 text-slate-600">
              A Reforma Tributária exige adequações imediatas e precisas. Nosso time é especializado no
              <strong> Configurador de Tributos do TOTVS Protheus</strong>, garantindo regras fiscais
              corretas, compliance e continuidade operacional sem sobressaltos.
            </p>
            <ul className="mt-6 space-y-3 text-slate-700" >
              <li className="flex items-start gap-3"><span className="mt-1 h-2.5 w-2.5 rounded-full bg-blue-600"/> Diagnóstico fiscal e mapeamento de regras atuais.</li>
              <li className="flex items-start gap-3"><span className="mt-1 h-2.5 w-2.5 rounded-full bg-blue-600"/> Parametrização e revisão do Configurador de Tributos.</li>
              <li className="flex items-start gap-3"><span className="mt-1 h-2.5 w-2.5 rounded-full bg-blue-600"/> Homologação ponta a ponta e treinamentos.</li>
              <li className="flex items-start gap-3"><span className="mt-1 h-2.5 w-2.5 rounded-full bg-blue-600"/> Acompanhamento pós-go-live e governança.</li>
            </ul>
            <div className="mt-6 flex gap-3">
              <a href="#contato" className="rounded-2xl bg-slate-900 text-white px-5 py-3 text-sm font-semibold hover:opacity-90">Quero ajustar meus tributos</a>
              <a href="#servicos" className="rounded-2xl border border-slate-600 px-5 py-3 text-sm font-semibold hover:bg-slate-100">Ver todos os serviços</a>
            </div>
          </div>
          <div className="relative" >
            <div className="absolute -inset-2 bg-gradient-to-tr from-blue-200 to-slate-200 rounded-3xl blur"/>
            <div className="relative rounded-3xl bg-white p-3 shadow-xl border border-slate-900">
              <center><h3 className="text-lg font-semibold text-slate-900">Plano de adequação sugerido</h3></center>
              <ol className="mt-2 list-decimal pl-4 text-slate-700 space-y-1">
                <li>Levantamento das operações e regras tributárias.</li>
                <li>Adequação IBS e CBS</li>                
                <li>ICMS, DIFAL e Regras por NCM / CFOP</li>
                <li>Testes integrados antes da entrada em produção.</li>
                <li>Documentação e treinamento da equipe.</li>
                <li>Suporte e acompanhamento na virada operacional.</li>
              </ol>
              <div className="mt-2 rounded-2xl bg-slate-50 p-2 border border-slate-200">
                <center><p className="text-sm text-slate-600">Investimento: <span className="font-semibold text-slate-900">Entre em contato para mais informações</span></p></center>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section id="servicos" className="mx-auto max-w-7xl px-6 py-2 bg-gradient-to-br from-slate-200 via-blue-100 to-blue-200">
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">Serviços</h2>
        <p className="mt-3 text-slate-500 max-w-1xl">Atuamos ponta a ponta no ecossistema TOTVS Protheus, com serviços de alto impacto para acelerar resultados.</p>
        <div className="mt-4 grid gap-6 sm:grid-cols- lg:grid-cols-3" >
          {[
            {title:"Suporte & Melhorias",desc:"Parametrizações, troubleshooting, performance e otimizações."},
            {title:"Migração de Versão",desc:"Planejamento, execução, testes e validação do ambiente."},
            {title:"Coordenação de Sistemas",desc:"Governança, integração e roadmap para o uso eficiente do ERP."},
            {title:"Desenvolvimento",desc:"ADVPL, APIs, WebServices e integrações (incluindo PHP)."},
            {title:"Compliance Fiscal",desc:"Configuração tributária aderente à Reforma Tributária."},
            {title:"Treinamento & Handoff",desc:"Capacitação de usuários chave e transferência de conhecimento."},
          ].map((c,idx)=> (
            <div key={idx} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-md transition border border-slate-500">
              <h3 className="text-lg font-semibold text-slate-900">{c.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Módulos */}
      <section id="modulos" className="mx-auto max-w-7xl px-6 py-2 bg-gradient-to-br from-slate-200 via-blue-100 to-blue-200">
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">Módulos de Atuação</h2>
        <div className="mt-6 grid gap-6 lg:grid-cols-3">
          <Card title="Gestão de Pessoal & RH" items={["Folha de Pagamento","Ponto Eletrônico","eSocial","Cargos & Salários","Treinamento","Recrutamento & Seleção","Arquitetura Organizacional","Portal Candidato","APP MeuRH"]} />
          <Card title="BackOffice" items={["Compras","Estoque & Custos","Faturamento","Financeiro","Contabilidade","Fiscal"]} />
          <Card title="Gestão & Operações" items={["PCP","PCO","Ativo Fixo","Manutenção de Ativos","Manutenção de Frota","WMS","OMS","Contratos","Importação (EIC)","Call Center (TMK)"]} />
        </div>
      </section>

      {/* Preço */}
      <section id="preco" className="mx-auto max-w-7xl px-6 py-7 bg-gradient-to-br from-slate-200 via-blue-50 to-blue-200">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">Banco de Horas</h2>
            <p className="mt-3 text-slate-600 max-w-2xl">Condição especial para contratação (mínimo de 200 horas).</p>
            <ul className="mt-4 text-slate-700 space-y-2">
              <li className="flex items-center gap-3"><span className="h-2.5 w-2.5 rounded-full bg-blue-600"/> Suporte</li>
              <li className="flex items-center gap-3"><span className="h-2.5 w-2.5 rounded-full bg-blue-600"/> Implantação de Módulos</li>
              <li className="flex items-center gap-3"><span className="h-2.5 w-2.5 rounded-full bg-blue-600"/> Desenvolvimento ADVPL, TLPP e POUI</li>
              <li className="flex items-center gap-3"><span className="h-2.5 w-2.5 rounded-full bg-blue-600"/> Atuação remota ou presencial</li>
              <li className="flex items-center gap-3"><span className="h-2.5 w-2.5 rounded-full bg-blue-600"/> Contratos flexíveis e sob demanda</li>
            </ul>
          </div>
          <div className="relative">
            <div className="absolute -inset-2 bg-gradient-to-tr from-slate-200 to-blue-200 rounded-3xl blur"/>
            <div className="relative rounded-3xl bg-white p-4 border border-slate-500 shadow-x2 text-center">
              <div className="text-sm uppercase tracking-wider text-slate-500">Serviços Protheus</div>
              <div className="mt-0 text-3xl font-extrabold text-slate-900">(consulte)<span className="text-base font-medium text-slate-500"> / hora (remota)</span></div>
              <div className="mt-0 text-sm text-slate-600">Valor sem impostos. Consulte condições.</div>
              <a href="#contato" className="mt-3 inline-flex items-center justify-center rounded-2xl bg-slate-900 px-3 py-1 text-white font-semibold hover:opacity-90">Solicitar proposta</a>
            </div>
          </div>
        </div>
      </section>

      {/* Contato */}
      <section id="contato" className="mx-auto max-w-7xl px-6 py-2 bg-gradient-to-br from-slate-200 via-blue-100 to-blue-200">
        <div className="grid lg:grid-cols-2 gap-8">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">Fale com a RMA Sistemas</h2>
            <p className="mt-3 text-slate-600">Conte um pouco da sua necessidade e retornaremos rapidamente.</p>
            <div className="mt-6 space-y-3 text-slate-700">
              <p>WhatsApp: <a className="font-semibold hover:underline" href="https://wa.me/5583993721277" target="_blank">(83) 99372.1277</a></p>
              <p>E-mail: <a className="font-semibold hover:underline" href="mailto:rodrigo@rmasistemas.com.br">rodrigo@rmasistemas.com.br</a></p>
              <p>Atendimento em todo o Brasil, remoto ou presencial.</p>
            </div>
          </div>
          <div className="rounded-3xl bg-white p-6 border border-slate-200 shadow-sm">
            <form action="mailto:rodrigo@rmasistemas.com.br" method="post" encType="text/plain" className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700">Nome</label>
                <input required className="mt-1 w-full rounded-2xl border border-slate-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" name="nome" placeholder="Seu nome"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700">E-mail</label>
                <input required type="email" className="mt-1 w-full rounded-2xl border border-slate-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" name="email" placeholder="voce@empresa.com.br"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700">Assunto</label>
                <input className="mt-1 w-full rounded-2xl border border-slate-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" name="assunto" placeholder="Ex.: Adequação Reforma Tributária"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700">Mensagem</label>
                <textarea rows={4} className="mt-1 w-full rounded-2xl border border-slate-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" name="mensagem" placeholder="Descreva sua demanda"/>
              </div>
              <button type="submit" className="w-full rounded-2xl bg-slate-900 text-white px-6 py-3 font-semibold hover:opacity-90">Enviar</button>
              <p className="text-xs text-slate-500">Ao clicar em Enviar, seu cliente de e-mail padrão será aberto com os dados preenchidos.</p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-black">
        <div className="mx-auto max-w-7xl px-6 py-2 text-sm text-slate-600">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p>© {new Date().getFullYear()} RMA Sistemas — Especialistas em TOTVS Protheus.</p>
            <div className="flex items-center gap-4">
              <a href="#home" className="hover:underline">Início</a>
              <a href="#tributos" className="hover:underline">Reforma Tributária</a>
              <a href="#contato" className="hover:underline">Contato</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

function Card({title, items}:{title:string, items:string[]}){
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      <div className="mt-4 flex flex-wrap gap-2">
        {items.map((i,idx)=> (
          <span key={idx} className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs text-slate-700">{i}</span>
        ))}
      </div>
    </div>
  );
}
